export const IMAGE_SIZE_CLASS_NAME = {
	SIZE_60: 'imageSize-60',
	SIZE_70: 'imageSize-70',
	SIZE_80: 'imageSize-80',
	SIZE_90: 'imageSize-90',
	SIZE_100: 'imageSize-100'
};